export default {

    END_POINT_DEFAULT: process.env.VUE_APP_ENDPOINT_DEFAULT,
    END_POINT_PORTAL_CORPORATIVO: process.env.VUE_APP_END_POINT_PORTAL_CORPORATIVO,
    
    SSO_END_POINT: process.env.VUE_APP_ENDPOINT_SSO,

    SSO_REDIRECT_LOGIN_URL: process.env.VUE_APP_LOCATION_URL + "authorized/?",
    SSO_REDIRECT_LOGOUT_URL: "https://www.cna.com.br",

    SSO_CLIENT_ID: "account-user",
    SSO_RESPONSE_TYPE: "id_token token",
    SSO_SCOPE: "openid profile email account_user_api",

    ACCESS_TOKEN: "PFB_AC_T_X857D",
    ID_TOKEN: "PFB_ID_T_D98SW",
    USER_INFO: "PFB_U_I_D8D5D",
    ID_STATE: "PFB_ID_S_852PL",

    CHAVE_IDENTIFICACAO_SISTEMA: "SHOPPING_NOVO",

    URL_SHOPPING_CNA: process.env.VUE_APP_SHOPPING_URL,
    URL_PORTAL_CORPORATIVO: process.env.VUE_APP_PORTAL_CORPORATIVO,
    URL_DOWNLOAD: process.env.VUE_APP_ENDPOINT_DOWNLOAD + '/document/download/',
    URL_CNA_NET: process.env.VUE_APP_CNA_NET_URL,


}
